import React from "react";
import { BookOption, Product } from "../types/Product";
import { Row, Column, Spacing } from "../helpers/layout";
import { css } from "styled-components";
import { addToCart } from "../actions/addToCart";
import { addToWishlist } from "../actions/addToWishlist";
import { ProductPreview } from "./ProductPreview";
import { BigTitle, ProductSerie } from "../typography";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import { EditorContent } from "./EditorContent";
import { useResponsive } from "../context/ResponsiveContext";
import { ProductDetailFooter } from "./ProductDetailFooter";
import { Wrapper } from "./Wrapper";
import { useRecentlyViewed } from "../context/RecentlyViewedContext";
import { addToRecentlyViewed } from "../actions/addToRecentlyViewed";
import ProductGallery from "./ProductGallery";
import { TABLET } from "../branding";
import ShopProductAwards from "./ShopProductAwards";

export function DefaultProductDetail(props: { product: Product }) {
  const { product } = props;
  const { fetchCart } = useCart();
  const { fetchWishlist } = useWishlist();
  const { recentlyViewed, fetchRecentlyViewed } = useRecentlyViewed();
  const { isTablet, isMobile } = useResponsive();
  const Layout = isTablet || isMobile ? Column : Row;
  return (
    <Wrapper>
      <Layout gutter={Spacing.xxl}>
        <div
          css={css`
            flex: 0 0 35%;
            width: 35%;
            position: relative;

            @media (max-width: ${TABLET}px) {
              width: 100%;
            }
          `}
        >
          {product.type === "BOOK" &&
          props.product.book_carousel.items?.length ? (
            <ProductGallery items={props.product.book_carousel.items} />
          ) : (
            <ProductPreview product={product} />
          )}
        </div>
        <div
          css={css`
            flex: 1 0 20%;
          `}
        >
          <Column gutter={Spacing.xl}>
            <div
              css={css`
                text-align: center;
              `}
            >
              <BigTitle>{product.name}</BigTitle>
              {product.subtitle && (
                <ProductSerie
                  css={css`
                    margin-bottom: ${Spacing.m};
                  `}
                >
                  {product.subtitle}
                </ProductSerie>
              )}
              {product.serie && (
                <ProductSerie>{product.serie.name}</ProductSerie>
              )}
              <ShopProductAwards awards={product.awards} />
            </div>
            {product.content && (
              <div>
                <EditorContent text={product.content} />
              </div>
            )}
            <ProductDetailFooter
              product={product}
              total={product.price || "0"}
              onAddToCart={async (bookOpt: BookOption | null) => {
                await addToCart({
                  product: product.id,
                  productType: product.type,
                  options: [],
                  book_option: bookOpt,
                });

                await fetchCart();
              }}
              onAddToWishlist={async (bookOpt) => {
                await addToWishlist({
                  product: product.id,
                  options: [],
                  book_option: bookOpt,
                });

                await fetchWishlist();

                // Add item to recently viewed
                await addToRecentlyViewed(recentlyViewed.uuid, {
                  product: product.id,
                });

                await fetchRecentlyViewed();
              }}
            />
          </Column>
        </div>
      </Layout>
    </Wrapper>
  );
}
